import { ACCESS_USER_TYPE } from "./constants";

export const checkAppAccessibility = (userType) => {
    if (!userType) return false;
    const accessibleUsers = ACCESS_USER_TYPE.split(" ").map((val) => val.toUpperCase());
    return accessibleUsers.includes(userType.toUpperCase());
}